var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isScreen
        ? _c(
            "header",
            { staticClass: "header" },
            [
              _c("p", { staticClass: "headerP1" }, [_vm._v("筛选")]),
              _c("div", {
                staticStyle: {
                  height: "0.34rem",
                  "border-right": "1px solid #53B0A3",
                  width: "1px",
                  "margin-right": "0.24rem",
                },
              }),
              _c("el-input", {
                staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                attrs: { placeholder: "团号", size: "small", type: "number" },
                model: {
                  value: _vm.q.planId,
                  callback: function ($$v) {
                    _vm.$set(_vm.q, "planId", $$v)
                  },
                  expression: "q.planId",
                },
              }),
              _c("el-input", {
                staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                attrs: { placeholder: "id", size: "small", type: "number" },
                model: {
                  value: _vm.q.id,
                  callback: function ($$v) {
                    _vm.$set(_vm.q, "id", $$v)
                  },
                  expression: "q.id",
                },
              }),
              _c("el-input", {
                staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                attrs: { placeholder: "操作人", size: "small" },
                model: {
                  value: _vm.q.createName,
                  callback: function ($$v) {
                    _vm.$set(_vm.q, "createName", $$v)
                  },
                  expression: "q.createName",
                },
              }),
              _c("el-input", {
                staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                attrs: { placeholder: "收款内容", size: "small" },
                model: {
                  value: _vm.q.chargingContent,
                  callback: function ($$v) {
                    _vm.$set(_vm.q, "chargingContent", $$v)
                  },
                  expression: "q.chargingContent",
                },
              }),
              _c("el-input", {
                staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                attrs: { placeholder: "付款方名称", size: "small" },
                model: {
                  value: _vm.q.payName,
                  callback: function ($$v) {
                    _vm.$set(_vm.q, "payName", $$v)
                  },
                  expression: "q.payName",
                },
              }),
              _c("el-input", {
                staticStyle: { width: "1.8rem", "margin-right": "0.1rem" },
                attrs: { placeholder: "订单编号", size: "small" },
                model: {
                  value: _vm.q.collectionId,
                  callback: function ($$v) {
                    _vm.$set(_vm.q, "collectionId", $$v)
                  },
                  expression: "q.collectionId",
                },
              }),
              _c("el-date-picker", {
                staticStyle: { "margin-right": "0.1rem", width: "1.5rem" },
                attrs: {
                  placeholder: "选择日期",
                  size: "small",
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                },
                on: {
                  change: function ($event) {
                    ;(_vm.page = 1), _vm.getList()
                  },
                },
                model: {
                  value: _vm.q.payDateStr,
                  callback: function ($$v) {
                    _vm.$set(_vm.q, "payDateStr", $$v)
                  },
                  expression: "q.payDateStr",
                },
              }),
              _c("el-input", {
                staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                attrs: {
                  placeholder: "收款金额",
                  size: "small",
                  type: "number",
                },
                model: {
                  value: _vm.q.payPrice,
                  callback: function ($$v) {
                    _vm.$set(_vm.q, "payPrice", $$v)
                  },
                  expression: "q.payPrice",
                },
              }),
              _c(
                "el-select",
                {
                  staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                  attrs: { placeholder: "付款方式", size: "small" },
                  on: {
                    change: function ($event) {
                      ;(_vm.page = 1), _vm.getList()
                    },
                  },
                  model: {
                    value: _vm.q.payType,
                    callback: function ($$v) {
                      _vm.$set(_vm.q, "payType", $$v)
                    },
                    expression: "q.payType",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                  attrs: { placeholder: "收款状态", size: "small" },
                  on: {
                    change: function ($event) {
                      ;(_vm.page = 1), _vm.getList()
                    },
                  },
                  model: {
                    value: _vm.q.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.q, "status", $$v)
                    },
                    expression: "q.status",
                  },
                },
                _vm._l(_vm.options1, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-search",
                    size: "small",
                    type: "primary",
                  },
                  on: {
                    click: function ($event) {
                      ;(_vm.page = 1), _vm.getList()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-search", size: "small" },
                  on: { click: _vm.resetClick },
                },
                [_vm._v("重 置")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticStyle: { padding: "0.15rem 0", color: "red" } }, [
        _vm._v(" 勾选总金额： " + _vm._s(_vm.checkTheTotalAmount) + "¥ "),
      ]),
      _c("footer", { staticClass: "footer" }, [
        _c(
          "div",
          { staticStyle: { border: "1px solid #ebeef5" } },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  "header-cell-style": {
                    backgroundColor: "#F1FAF9",
                    color: "#000000",
                  },
                  "summary-method": _vm.getSummaries,
                  border: "",
                  "show-summary": "",
                  "tooltip-effect": "dark",
                },
                on: { select: _vm.select, "select-all": _vm.selectAll },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    fixed: "left",
                    type: "selection",
                    width: "55",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    fixed: "left",
                    label: "团号",
                    prop: "planId",
                    width: "180",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.order.planId))]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    fixed: "left",
                    label: "收款内容",
                    width: "180",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(" " + _vm._s(scope.row.order.chargingContent)),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "收款时间", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("dateFormat")(scope.row.payDate))
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "付款方名称",
                    prop: "payName",
                    width: "250",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "金额",
                    prop: "payPrice",
                    width: "150",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.payPrice) +
                              _vm._s(scope.row.order.currency)
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "退款金额",
                    prop: "refundPrice",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "实际到帐金额",
                    prop: "actualArrival",
                    width: "150",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.status === 0 || scope.row.status === 2
                                  ? 0
                                  : (
                                      scope.row.actualArrival *
                                      Number(scope.row.rate)
                                    ).toFixed(2)
                              ) +
                              " ¥ "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "已开票金额", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.invoicePrice
                                  ? "¥" + scope.row.invoicePrice
                                  : "未开票"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.isRefund
                  ? _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: "退款提请金额",
                        prop: "refundPrice",
                        width: "180",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " + _vm._s(Number(scope.row.refundPrice))
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1829524023
                      ),
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: { align: "center", label: "付款方式", width: "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.payType == 1 ? "微信" : "线下转账"
                              )
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "状态", width: "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.status === 0 || scope.row.status === 2
                                  ? "未到账"
                                  : scope.row.status === 3
                                  ? "退款中..."
                                  : "已到账"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "备注", width: "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.remark))]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "createName",
                    label: "操作人",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "createCompanyName",
                    label: "操作公司",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    fixed: "right",
                    label: "操作",
                    width: "80",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "background-color": "#3EC8DD",
                                "border-color": "#3EC8DD",
                              },
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.save(scope.row)
                                },
                              },
                            },
                            [_vm._v("委托收款 ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("pagination", {
              attrs: { pageSizes: _vm.pageSizes, totalNumber: _vm.totalNumber },
              on: { loadTable: _vm.loadTable },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible1,
            title: "委托收款",
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible1 = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("p", { staticStyle: { "margin-bottom": "10px" } }, [
                _vm._v("请输入你要委托收款的供应商 ID"),
              ]),
              _c("el-input", {
                staticStyle: { width: "250px" },
                attrs: { placeholder: "请输入供应商ID", type: "number" },
                model: {
                  value: _vm.checkObj.procurationCompanyId,
                  callback: function ($$v) {
                    _vm.$set(_vm.checkObj, "procurationCompanyId", $$v)
                  },
                  expression: "checkObj.procurationCompanyId",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible1 = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmCommission },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }